import {
	Box,
	Button,
	FormHelperText,
	Paper,
	Stack,
	TextField,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { type FieldError, useFormContext } from 'react-hook-form'
import MediaModal from '../../../../../components/Modals/MediaModal'
import type { Image } from '../../../../../types/Image'
import type { EditPost } from '../../../../../types/Post/EditPost'
import type { CreateStep } from '../../../../../types/Step'
import OptionsMenu from './options-menu'

interface StepProps {
	index: number
	step: CreateStep & { image?: Image | null }
	errors?: {
		description?: FieldError
		imageId?: FieldError
	}
}

export default function Step({ index, step, errors }: StepProps) {
	const [mediaModalOpen, setMediaModalOpen] = useState(false)
	const [selectedImage, setSelectedImage] = useState<Image | null>(
		step.image || null
	)

	const { watch } = useFormContext<EditPost>()

	const steps = watch('steps')

	const { setValue } = useFormContext<EditPost>()

	function handleDescriptionChange(description: string) {
		setValue(`steps.${index}.description`, description)
	}

	function handleDelete() {
		const stepsWithoutDeleted = steps?.filter((_, i) => i !== index) ?? []

		setValue('steps', stepsWithoutDeleted)
	}

	useEffect(() => {
		setValue(`steps.${index}.imageId`, selectedImage?.id ?? null)
	}, [selectedImage, index, setValue])

	return (
		<>
			<MediaModal
				open={mediaModalOpen}
				setOpen={setMediaModalOpen}
				setSelectedImage={setSelectedImage}
				resource='STEP'
			/>
			<Stack
				direction='column'
				gap={0}
				component={Paper}
				variant='outlined'
				p={1}
			>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: '4px' }}>
					<OptionsMenu onDelete={handleDelete} />
				</Box>
				<Stack direction='row' gap={2}>
					{!selectedImage ? (
						<Button
							variant='contained'
							component='span'
							sx={{
								width: '200px',
								height: '150px',
								backgroundColor: '#f0f0f0',
								color: 'black',
								':hover': {
									backgroundColor: '#D3D3D3',
								},
								flexShrink: 0,
								padding: 0,
							}}
							onClick={() => setMediaModalOpen(true)}
						>
							Definir imagem
						</Button>
					) : (
						<Button
							sx={{
								width: '200px',
								height: '150px',
								flexShrink: 0,
							}}
							onClick={() => setMediaModalOpen(true)}
						>
							<img
								style={{ width: '100%', height: '100%' }}
								src={selectedImage.url}
								alt={selectedImage?.alt || `Imagem do passo ${step.order}`}
							/>
						</Button>
					)}

					<TextField
						fullWidth
						multiline
						rows={5}
						value={step.description}
						onChange={e => handleDescriptionChange(e.target.value)}
						error={!!errors?.description}
					/>
				</Stack>
				<FormHelperText error={!!errors?.imageId}>
					{errors?.imageId?.message}
				</FormHelperText>
				<FormHelperText error={!!errors?.description}>
					{errors?.description?.message}
				</FormHelperText>
			</Stack>
		</>
	)
}
